import api from "api/api";

export const createSubcontractorQuery = async ({ data, userScope }) =>
  await api.post(`/directory/subcontractor?scope=${userScope}`, data);

export const getSubcontractorQuery = async ({ id, userScope }) =>
  await api.get(`/directory/subcontractor/${id}?scope=${userScope}`);

export const updateSubcontractorQuery = async ({ id, data, userScope }) =>
  await api.put(`/directory/subcontractor/${id}?scope=${userScope}`, data);

export const deleteSubcontractorQuery = async ({ id, userScope }) =>
  await api.delete(`/directory/subcontractor/${id}?scope=${userScope}`);

export const getSubcontractorBySlugQuery = async ({ slug, userScope }) =>
  await api.get(`/directory/subcontractor/slug/${slug}?scope=${userScope}`);

export const getSubcontractorsBySubcontractorCompanyQuery = async ({
  id,
  userScope,
}) =>
  await api.get(
    `/directory/subcontractor/subcontractor_company/id/${id}?scope=${userScope}`
  );
